import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44a87f81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-redemption-button-section" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Modify ")
const _hoisted_4 = {
  key: 0,
  class: "spinner"
}
const _hoisted_5 = {
  key: 1,
  id: "disabledCta",
  class: "m-redemption-button",
  disabled: ""
}
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.redemptionCompleted && _ctx.canModify)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          id: "modifyButton",
          role: "button",
          class: "m-redemption-button",
          disabled: _ctx.modifying,
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.modifyClicked && _ctx.modifyClicked(...args)), ["prevent"]))
        }, [
          _hoisted_3,
          (_ctx.modifying)
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.redemptionCompleted || _ctx.showQueuePosition)
      ? (_openBlock(), _createElementBlock("button", _hoisted_5, _toDisplayString(_ctx.disabledCtaText), 1))
      : (_openBlock(), _createElementBlock("a", {
          key: 2,
          id: "shopifyLink",
          class: "m-redemption-button",
          href: _ctx.shopifyInvoiceLink,
          target: "_blank"
        }, _toDisplayString(_ctx.mainCtaText), 9, _hoisted_6))
  ]))
}